import axios from 'axios';
import store from "element-ui/packages/cascader-panel/src/store";


const STAGING_API_URL = 'https://curascript-backend.staging9.com/api/v1/';
const PRODUCTION_API_URL = 'http://admin.curascript.co.za/api/v1/';
const LOCAL_API_URL = 'http://127.0.0.1:8000/api/v1/';

const getApiUrl = () => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return LOCAL_API_URL;
    }
    if (/staging9|staging|stg|uat/i.test(hostname)) {
        return STAGING_API_URL;
    }

    return PRODUCTION_API_URL;
};

const url = getApiUrl();

// Helps quickly confirm deployed environment in browser console.
console.info(`[API_URL] mode=${process.env.NODE_ENV} host=${window.location.hostname} url=${url}`);


const HTTP = axios.create({ 
    baseURL: `${url}`,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
        'deviceType': 1,
        'deviceId': "ss",
        'deviceToken': "asdasd",
    }
});

axios.defaults.baseURL = `${url}`;

export const sendOtp = ({
    commit
}, data) => {
    commit('setLoading', true);
    return HTTP.post('send-otp',
        data, {}).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const login = ({
    commit
}, data) => {
    commit('setLoading', true);
    return HTTP.post('login',
        data, {}).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const logout = ({
    commit,
    getters
}) => {
    commit('setLoading', true);

    return HTTP.post('logout', {
        "deviceId": getters.login.deviceId
    }, {
        headers: {
            Authorization: `Bearer ` + getters.login.token
        }
    }).then((response) => {
        commit('clearLogin');
        commit('setLoading', false);
        commit('setUnauthorized', false);
        return response;
    }, (err) => {
        if (err.response.status == 401) {
            commit('clearLogin');
            commit('setUnauthorized', true);
            return err.response;
        }
        commit('setLoading', false);
        return err.response;
    });
};

export const createScript = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('script/create',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const getSignature = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('get-doctor-signature',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const getPatientDetails = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('patient/list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

export const getPastScriptList = ({
    commit,
    getters
}, data, id) => {
    commit('setLoading', true);
    return HTTP.post('script/list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

export const getAllPastScriptList = ({
    commit,
    getters
}, data, id) => {
    commit('setLoading', true);
    return HTTP.post('script/alllist',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};


export const getPastScriptDetails = ({
    commit,
    getters
}, data, id) => {
    commit('setLoading', true);
    return HTTP.post('script/detail',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const getPharmacistDetails = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('my-pharmacists',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setUnauthorized', false);
            commit('setLoading', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const uploadImages = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('script/upload-script-images',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setUnauthorized', false);
            commit('setLoading', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const contactDetails = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('/settings',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const patientList = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('patient/my-patients',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const fetchDoctorData = ({
    commit,
    getters
}) => {
    commit('setLoading', true);
    return HTTP.post('fetch-doctor-data',
        {}, {
            headers: {
                Authorization: `Bearer ` + getters.login.token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response && err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response || err;
    }).catch(reason => {
        commit('setLoading', false);
        return reason;
    });
};

export const changeTariff = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('change-tariff',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const paymentHistory = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('payment-summary',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

export const appointmentList = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('appointment/list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

// export const getGroupRequestList = ({
//     commit,
//     getters
// }, data) => {
//     commit('setLoading', true);
//     return HTTP.post('group-request/list',
//         data, {
//             headers: {
//                 Authorization: `Bearer ` + getters.login.token
//             }
//         }).then((response) => {
//         if (response.status === 200) {
//             commit('setLoading', false);
//             commit('setUnauthorized', false);
//             return response.data;
//         }
//     }, (err) => {
//         commit('setLoading', false);
//         if (err.response.status == 401) {
//             commit('setUnauthorized', true);
//         }
//         return err.response.data;
//     }).catch(reason => {
//         console.log('reason', JSON.stringify(reason));
//         return reason;
//     });
// };

// 

// export const rejectGroupRequest = ({
//     commit,
//     getters
// }, data) => {
//     commit('setLoading', true);
//     return HTTP.post('group-request/reject',
//         data, {
//             headers: {
//                 Authorization: `Bearer ` + getters.login.token
//             }
//         }).then((response) => {
//         if (response.status === 200) {
//             commit('setLoading', false);
//             commit('setUnauthorized', false);
//             return response.data;
//         }
//     }, (err) => {
//         commit('setLoading', false);
//         if (err.response.status == 401) {
//             commit('setUnauthorized', true);
//         }
//         return err.response.data;
//     }).catch(reason => {
//         console.log('reason', JSON.stringify(reason));
//         return reason;
//     });
// };

// export const sendNoteToNurse = ({
//     commit,
//     getters
// }, data) => {
//     commit('setLoading', true);
//     return HTTP.post('group-request/note-to-nurse',
//         data, {
//             headers: {
//                 Authorization: `Bearer ` + getters.login.token
//             }
//         }).then((response) => {
//         if (response.status === 200) {
//             commit('setLoading', false);
//             commit('setUnauthorized', false);
//             return response.data;
//         }
//     }, (err) => {
//         commit('setLoading', false);
//         if (err.response.status == 401) {
//             commit('setUnauthorized', true);
//         }
//         return err.response.data;
//     }).catch(reason => {
//         console.log('reason', JSON.stringify(reason));
//         return reason;
//     });
// };

export const changeNotificationStatus = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('update/notification-status',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

// export const assignToDoctor = ({
//     commit,
//     getters
// }, data) => {
//     commit('setLoading', true);
//     return HTTP.post('group-request/assign-to-doctor',
//         data, {
//             headers: {
//                 Authorization: `Bearer ` + getters.login.token
//             }
//         }).then((response) => {
//         if (response.status === 200) {
//             commit('setLoading', false);
//             commit('setUnauthorized', false);
//             return response;
//         }
//     }, (err) => {
//         commit('setLoading', false);
//         if (err.response.status == 401) {
//             commit('setUnauthorized', true);
//         }
//         return err.response;
//     }).catch(reason => {
//         console.log('reason', JSON.stringify(reason));
//         return reason;
//     });
// };

export const menuNotificationCount = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('menu-notification-count',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);

            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

export const updateDeviceInformation = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('update-device-information',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

export const shareScriptViaSMS = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('script/share-script-via-sms',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

export const prescriptionSuggestions = ({
    commit,
    getters
}, data) => {
    return HTTP.post('/prescription-list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

export const icd10Codes = ({
    commit,
    getters
}, data) => {
    return HTTP.post('/icdCode-list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};
export const rejectAppointmentRequest = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('appointment/reject',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};
export const getPastAppointmentDetails = ({
    commit,
    getters
}, data, id) => {
    commit('setLoading', true);
    return HTTP.post('appointment/detail',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};


// chat
export const chatConversationList = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('/chat/conversation-list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};


export const chatConversation = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('/chat/conversation',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};




export const chatCreate = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('/chat/create',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        return reason;
    });
};

// changes

export const getGroupRequestList = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('request/list',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};


// past rejectGroupRequest
export const rejectGroupRequest = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('request/reject',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

// request assign to doctor

export const assignToDoctor = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('request/assign-to-doctor',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};


//
export const sendNoteToNurse = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('request/note-to-nurse',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response.data;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};

//
export const deletePrescription = ({
    commit,
    getters
}, data) => {
    commit('setLoading', true);
    return HTTP.post('exclude-script-prescription',
        data, {
            headers: {
                Authorization: `Bearer ` + getters.login.token
            }
        }).then((response) => {
        if (response.status === 200) {
            commit('setLoading', false);
            commit('setUnauthorized', false);
            return response;
        }
    }, (err) => {
        commit('setLoading', false);
        if (err.response.status == 401) {
            commit('setUnauthorized', true);
        }
        return err.response.data;
    }).catch(reason => {
        console.log('reason', JSON.stringify(reason));
        return reason;
    });
};